import { Route, Routes as RoutesContainer } from 'react-router';
import { SportRule, Create, Edit, Rank } from '../index';

const Routes = () => {
  return (
    <RoutesContainer>
      <Route exact path='/sport-rule' element={<SportRule />} />
      <Route exact path='/sport-rule/create' element={<Create />} />
      <Route exact path='/sport-rule/edit/:id' element={<Edit />} />
      <Route exact path='/sport-rule/rank/print' element={<Rank />} />
    </RoutesContainer>
  );
};
export default Routes;
